import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogStatusComponent } from 'src/app/dialog/dialog-status/dialog-status.component';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';
import { ToolsManageAccountsComponent } from '../tools-manage-accounts.component';

@Component({
    selector: 'app-add-user-account',
    templateUrl: './tools-add-user-account.component.html',
    animations: [
        trigger('slider', [
            state('*', style({
                height: 0
            })),
            state('show', style({
                height: '*'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class ToolsAddUserAccountComponent implements OnInit {

  userAccount: UserAccount;
  roles: ValueIdPair[];
  markets: ValueIdPair[];

  constructor(private dialog: MatDialog, public service: AppService, public dialogRef: MatDialogRef<ToolsManageAccountsComponent>, private http: HttpClient, @Inject(MAT_DIALOG_DATA) public data, @Inject('BASE_URL') private baseUrl: string) { }

  ngOnInit() {
    this.GetMarkets();
    this.PopulateForm();
  }

  /** Gets all the markets from server */
  GetMarkets() {
    this.http.get<ValueIdPair[]>(this.baseUrl + 'api/account/getMarkets').subscribe(result => {
      this.markets = result;
    });
  }

  /** Submit button event for the form */
  OnSaveAccount() {
    // tslint:disable-next-line: max-line-length
    if (this.userAccount.username && this.userAccount.email && this.userAccount.firstName && this.userAccount.lastName && this.userAccount.phone) {

      this.http.post<GRSSResponse>(this.baseUrl + 'api/account/verifyForm', this.userAccount).subscribe(result => {
        if (result.statusCode === 1) {
          if (this.userAccount.challenge) {
            if (this.userAccount.challengeQuestion && this.userAccount.challengeAnswer) {
              this.OnClose();
            }
          } else {
            this.OnClose();
          }
        } else {

          if (!this.userAccount.mobile) {
            this.userAccount.mobile = null;
          }

          this.dialog.open(DialogStatusComponent, {
            disableClose: true,
            data: {
              title: 'User Account',
              message: result.statusMessage,
              innerHTML: true
            },
            position: { top: '5%' }
          });
        }
      });
    }
  }

  /** Closing the add/edit user account window with user account details */
  OnClose() {
    this.dialogRef.close(this.userAccount);
    this.service.isUpdateUserAccount = false;
  }

  /** Populates the form values with passing data from manage accounts (Parent) */
  PopulateForm() {
    this.userAccount = {
      userId: this.data.userId,
      generalMarketIds: this.data.generalMarketIds,
      username: this.data.username,
      password: '',
      firstName: this.data.firstName,
      lastName: this.data.lastName,
      email: this.data.email,
      phone: this.data.phone,
      mobile: this.data.mobile,
      roleName: this.data.roleName,
      enabled: this.data.enabled,
      manager: this.data.manager,
      readonly: this.data.readonly,
      twoFactor: this.data.twoFactor,
      challenge: this.data.challenge,
      challengeAnswer: this.data.challengeAnswer,
      challengeQuestion: this.data.challengeQuestion
    };
    if (this.userAccount.mobile === '0') {
      this.userAccount.mobile = null;
    }
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(null);
  }

}

/** Interface to access user account details */
interface UserAccount {
  userId: string;
  generalMarketIds: string[];
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  mobile: string;
  roleName: string;
  enabled: boolean;
  readonly: boolean;
  manager: boolean;
  twoFactor: boolean;
  challenge: boolean;
  challengeQuestion: string;
  challengeAnswer: string;
}


